import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, TextWrappingSide, TextWrappingType, VerticalAlign, WidthType } from "docx";

export function summaryNetwork1(certInNetworkCustomerName, certInNetworkStartDate, certInNetworkEndDate, certInNetworkTestingype) {

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return 'th';
            else {
                switch (day % 10) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                }
            }
        }
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const formattedDate = `${date.getDate()}`;
        const ordinalSuffix = getOrdinalSuffix(date.getDate());
        const formatMonth = monthNames[date.getMonth()];
        const formatYear = date.getFullYear();

        return {
            formattedDate,
            ordinalSuffix,
            formatMonth,
            formatYear
        };
    };

    const formattedStartDate = formatDate(certInNetworkStartDate);
    const formattedEndDate = formatDate(certInNetworkEndDate);

    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `${certInNetworkCustomerName} engaged ISECURION for performing a Vulnerability assessment and Penetration testing of the Internal Network Infrastructure to check compliance with security parameters. The security assessment was executed from ${certInNetworkCustomerName} Premises from `,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),

            new TextRun({
                text: formattedStartDate.formattedDate,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: formattedStartDate.ordinalSuffix,
                size: 22,
                superScript: true,
                font: "Calibri",
                color: '000000',
                italics: false
            }),

            new TextRun({
                text: formattedStartDate.formatMonth + ' ' + formattedStartDate.formatYear + ' ' + 'to',
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formattedDate,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: formattedEndDate.ordinalSuffix,
                superScript: true,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formatMonth + ' ' + formattedEndDate.formatYear + ' .',
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: certInNetworkTestingype,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            })
        ],
    })
}

export const summaryNetwork2 = new Paragraph({
    spacing: { before: 350, after: 300 },
    alignment:AlignmentType.JUSTIFIED,
    children: [new TextRun({
        text: "The goal of this vulnerability assessment was to identify possible exposures or breach of Confidentiality, Integrity and Availability and technological risk to the business, resulting from the vulnerabilities in the underlying technologies. The security testing exercise tried to uncover vulnerabilities in the operating system.",
        bold: false,
        color: "000000",
        size: 22,
        font: "Calibri"
    })],
})

export const summaryNetwork3 = new Paragraph({
    spacing: { before: 350, after: 300 },
    alignment:AlignmentType.JUSTIFIED,
    children: [new TextRun({
        text: "The testing team executed the security assessment using distinct tools and techniques. The findings of the assessment are to be used along with a risk management exercise, as a tool in developing an overall picture of the network.",
        bold: false,
        color: "000000",
        size: 22,
        font: "Calibri"
    })],
})

export const summaryNetwork4 = new Paragraph({
    spacing: { before: 350, after: 300 },
    alignment:AlignmentType.JUSTIFIED,
    children: [new TextRun({
        text: "At the conclusion of the outlined procedures, we have documented our results as follows: -",
        bold: false,
        color: "000000",
        size: 22,
        font: "Calibri"
    })],
})

export const summaryNetwork5 = new Paragraph({
    indent: { left: 600 },
    alignment:AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    spacing: { line: 300, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "The Assessment revealed Vulnerability of Critical, High and Medium Severities in the windows hosts and network devices that needs to be addressed.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: true
        })
    ]
})
